// src/summoner.ts
import { withMessage } from "io-ts-types/withMessage";
import { withValidate } from "io-ts-types/withValidate";
import { withFallback } from "io-ts-types/withFallback";
import { withEncode } from "io-ts-types/withEncode";
import { summonFor, AsOpaque as MorphicAsOpaque } from "@morphic-ts/batteries/summoner-ESBST";
var { summon: prodSummon, tagged: prodTagged } = summonFor({
  IoTsURI: { withMessage, withValidate, withEncode, withFallback }
});
var summon = prodSummon;
var tagged = prodTagged;
var AsOpaque = MorphicAsOpaque;
export {
  AsOpaque,
  summon,
  tagged
};
//# sourceMappingURL=index.js.map
